import { render, staticRenderFns } from "./FeaturedGifts.vue?vue&type=template&id=72eef5e2&scoped=true"
import script from "./FeaturedGifts.vue?vue&type=script&lang=js"
export * from "./FeaturedGifts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedGifts.vue?vue&type=style&index=0&id=72eef5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eef5e2",
  null
  
)

export default component.exports